import React from 'react'

const HomeOutlineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='15'
    viewBox='0 0 14 15'
    fill='none'
    {...props}
  >
    <path
      d='M3.9974 12.6654H5.9974V9.33203C5.9974 9.14314 6.06128 8.98481 6.18906 8.85703C6.31684 8.72925 6.47517 8.66536 6.66406 8.66536H9.33073C9.51962 8.66536 9.67795 8.72925 9.80573 8.85703C9.93351 8.98481 9.9974 9.14314 9.9974 9.33203V12.6654H11.9974V6.66536L7.9974 3.66536L3.9974 6.66536V12.6654ZM2.66406 12.6654V6.66536C2.66406 6.45425 2.71128 6.25425 2.80573 6.06536C2.90017 5.87648 3.03073 5.72092 3.1974 5.5987L7.1974 2.5987C7.43073 2.42092 7.6974 2.33203 7.9974 2.33203C8.2974 2.33203 8.56406 2.42092 8.7974 2.5987L12.7974 5.5987C12.9641 5.72092 13.0946 5.87648 13.1891 6.06536C13.2835 6.25425 13.3307 6.45425 13.3307 6.66536V12.6654C13.3307 13.032 13.2002 13.3459 12.9391 13.607C12.678 13.8681 12.3641 13.9987 11.9974 13.9987H9.33073C9.14184 13.9987 8.98351 13.9348 8.85573 13.807C8.72795 13.6793 8.66406 13.5209 8.66406 13.332V9.9987H7.33073V13.332C7.33073 13.5209 7.26684 13.6793 7.13906 13.807C7.01128 13.9348 6.85295 13.9987 6.66406 13.9987H3.9974C3.63073 13.9987 3.31684 13.8681 3.05573 13.607C2.79462 13.3459 2.66406 13.032 2.66406 12.6654Z'
      fill='currentcolor'
    />
  </svg>
)

export default HomeOutlineIcon
